import script from "./ViewAllTags.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllTags.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllTags.vue?vue&type=style&index=0&id=d0791554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0791554"]])

export default __exports__